<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import type { SideBarItemsType, SideBarItemType } from '~/schema/sidebar.schema'

withDefaults(defineProps<{
  title: string,
  items: SideBarItemsType,
  activePage?: boolean
}>(), {
  activePage: true
})

const route = useRoute()

const currentPath = computed(() => route.fullPath)

const NuxtLinkComponent = resolveComponent('NuxtLink')

const isCurrentPath = (item: SideBarItemType) => {
  return (typeof item.route === 'string' ? item.route : item.route.path) === currentPath.value
}
</script>

<template>
  <div class="w-full">
    <span class="font-bold pl-1">{{ title }}</span>
    <ul role="list" class="space-y-1 mt-2">
      <hr class="divider h-px border-t-0">
      <li v-for="(item, index) in items" :key="index" :class="[activePage && !item.children && currentPath.startsWith(typeof item.route === 'string' ? item.route : item.route.path) ? 'bg-sidebar-active-page' : 'no-active']">
        <NuxtLink v-if="!item.children" class="flex items-center gap-x-3.5 py-2.5 px-2.5 text-sm" :href="typeof item.route === 'string' ? item.route : item.route.path">
          <img v-if="item.svg" :src="item.svg" alt="Icon SVG">
          {{ item.title }}
        </NuxtLink>
        <Disclosure v-else v-slot="{ open }" as="div" :default-open="item.defaultOpen ?? false">
          <DisclosureButton class="flex items-center w-full text-left rounded-md p-2 gap-x-3 text-sm leading-6 font-semibold ">
            <ChevronRightIcon :class="[open ? 'rotate-90 text-gray-500' : 'text-gray-400', 'text-white h-5 w-5 shrink-0']" aria-hidden="true" />
            {{ item.title }}
          </DisclosureButton>
          <DisclosurePanel as="ul" class="bg-sidebar-active-page px-2 gap-1 flex flex-col py-1">
            <li
              v-for="(subItem, indexChildren) in item.children"
              :id="subItem.anchor ? `${subItem.anchorKey}${subItem.anchorValue}` : null"
              :key="indexChildren"
            >
              <DisclosureButton :as="NuxtLinkComponent" :href="typeof subItem.route === 'string' ? subItem.route : subItem.route.path" :class="[subItem.active || isCurrentPath(subItem) ? 'text-yellow-400 font-semibold' : 'no-active','block text-sm']">
                <div class="text-center shadow rounded border px-2 py-1.5 hover:bg-sidebar">
                  {{ subItem.title }}
                </div>
              </DisclosureButton>
            </li>
          </DisclosurePanel>
        </Disclosure>
        <hr class="divider h-px border-t-0">
      </li>
    </ul>
  </div>
</template>
